module.exports = __webpack_public_path__ + "static/media/table.035b5273.png";